import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccountService } from '@banyan/features/account/services/account.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function authInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  return _authInterceptor(inject(AccountService))(req, next);
}

export function _authInterceptor(accountService: AccountService) {
  return (req: HttpRequest<any>, next: HttpHandlerFn) =>
    next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          accountService.redirectUnauthorized();
        }
        return throwError(() => error);
      }),
    );
}
